module.exports = __webpack_public_path__ + "static/fonts/Montserrat-ExtraBold.19ba7aa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-ExtraBold.ttf
// module id = jorq
// module chunks = 1